package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Administrador
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import kotlin.js.Date
import androidx.compose.runtime.NoLiveLiterals
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD


@NoLiveLiterals
@Composable
fun MapScreen(
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit
) {
    val uiState by viewModel.uiState.collectAsState()
    val adminProfile = viewModel.adminProfile
    val incidenciasFiltradas by viewModel.incidenciasFiltradas.collectAsState()
    val markersJson by viewModel.mapMarkersJson.collectAsState()
    val markersSeguridadJson by viewModel.mapMarkersSeguridadJson.collectAsState()
    val gruposDeDelito = remember {
        listOf("Todos") + TipificacionesRepositoryCEAD.obtenerTodosLosGrupos()
    }



    Div({
        style {
            padding(20.px)
            fontFamily("sans-serif")
        }
    }) {
        Div({
            style {
                height(95.vh)
                backgroundColor(Color("#1976D2"))
                borderRadius(12.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                property("overflow", "hidden")
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    property("border-bottom", "2px solid #1565C0")
                }
            }) {
                Div({
                    style {
                        width(10.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                        alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                    }
                }) {
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                        Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                        H2({ style { fontSize(24.px); color(Color.white); margin(0.px); property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                            Span({ style { fontWeight("normal") } }) { Text("Linea") }
                            Span({ style { fontWeight("bold") } }) { Text("Muni") }
                        }
                        P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
                    }
                }

                Div({
                    style {
                        width(90.percent); padding(16.px, 24.px); boxSizing("border-box")
                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
                    }
                }) {
                    H1({
                        style {
                            color(Color.white); fontSize(32.px); fontWeight(700); flex(1);
                            textAlign("center"); margin(0.px); paddingTop(20.px)
                        }
                    }) { Text("Mapa General de Incidencias") }

                    FilterSectionMap(uiState, adminProfile, incidenciasFiltradas.size, viewModel, onBack, gruposDeDelito)
                }
            }

            MapContainer(uiState, markersJson, markersSeguridadJson, incidenciasFiltradas)


        }
    }
}

@Composable
private fun FilterSectionMap(
    uiState: AdminPanelUiState,
    adminProfile: Administrador,
    incidentCount: Int,
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit,
    gruposDeDelito: List<String>
) {
    Div({
        style {
            display(DisplayStyle.Flex);
            fontSize(16.px);
            fontWeight("bold")
            flexDirection(FlexDirection.Row);
            gap(24.px);
            padding(16.px);
            borderRadius(8.px)
            alignItems(AlignItems.Center);
            flexWrap(FlexWrap.Wrap);
            backgroundColor(Color("#f2f2f2"))
            width(100.percent);
            boxSizing("border-box")
        }
    }) {
        P({ style { marginRight(16.px); color(Color("#333333")) } }) {
            Text("Mostrando: $incidentCount")
        }

        FilterDropdown(
            "Mes:", uiState.filtroMes, uiState.mesesDisponibles, { viewModel.onFiltroMesChanged(it) },
            optionDisplayNames = uiState.mesesDisponibles.associateWith {
                val (year, month) = it.split("-")
                Date(year.toInt(), month.toInt() - 1).toLocaleString("es-CL", options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
            }
        )
        if (adminProfile.rol == "GENERAL") {
            FilterDropdown("Comuna:", uiState.filtroComuna, uiState.comunas.map { it.comunaDisplayName }.distinct(), { viewModel.onFiltroComunaChanged(it) })
        }
        FilterDropdown("Estado:", uiState.filtroEstado, listOf("EN_PROCESO", "SOLUCIONADO", "RECHAZADO", "VERIFICADO"), { viewModel.onFiltroEstadoChanged(it) })

        // 🛡️ REGLA DE ECONOMÍA VISUAL: Escondemos el filtro de tipo si es una especialidad fija
        val rolesConFiltro = listOf("GENERAL", "COMUNAL", "OPERADORA", "DIRECCION_DAO")
        if (adminProfile.rol.uppercase() in rolesConFiltro) {
            FilterDropdown("Tipo:", uiState.filtroTipo, viewModel.uiState.value.incidencias.mapNotNull { it.tipoIncidenciaDisplayName }.distinct().sorted(), { viewModel.onFiltroTipoChanged(it) })
        }

        if (uiState.filtroTipo == "Seguridad Ciudadana") {
            FilterDropdown(
                label = "Grupo Delito:",
                selectedValue = uiState.filtroGrupoDelito,
                options = gruposDeDelito, // Usamos la nueva lista
                onValueChanged = {
                    // Si se selecciona "Todos", pasamos null al ViewModel
                    val valorAEnviar = if (it == "Todos") null else it
                    viewModel.onFiltroGrupoDelitoChanged(valorAEnviar)
                }
            )
        }

        Div({ style { flex(1) } })

        Button(attrs = {
            onClick { onBack() };
            style {
                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white); backgroundColor(Color("#FB8C00"));
                borderWidth(0.px); borderRadius(8.px); cursor("pointer"); property("transition", "background-color 0.3s")
            }
        }) { Text("Volver al Panel") }
    }
}

@Composable
private fun MapContainer(
    uiState: AdminPanelUiState, markersJson: String, markersSeguridadJson: String, incidencias: List<Incidencia>
) {
    // --- ¡EL ESTANDARTE RESTAURADO CON SU GRITO DE GUERRA! ---
    key(incidencias) {
        H2({
            style {
                fontSize(24.px)
                color(Color.white)
                marginLeft(23.px)
                property("text-shadow", "1px 1px 3px rgba(0,0,0,0.5)")
            }
        }) {
            Span({ style { fontWeight("normal") } }) { Text("Incidencias Mostradas: ${incidencias.size}") }
        }
    }

    Div({
        style {
            flex(1)
            padding(24.px)
            paddingTop(16.px)
            boxSizing("border-box")
            display(DisplayStyle.Flex)
            position(Position.Relative)
        }
    }) {
        Div({
            id("map-canvas")
            style {
                width(100.percent)
                height(100.percent)
                borderRadius(8.px)
                border(2.px, LineStyle.Solid, Color("#1565C0"))
            }
        })

        if (incidencias.isEmpty()) {
            Div({
                style {
                    position(Position.Absolute)
                    top(0.px); left(0.px); width(100.percent); height(100.percent)
                    backgroundColor(Color("rgba(0, 0, 0, 0.6)")); display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                    color(Color.white); fontSize(18.px); fontWeight("bold"); borderRadius(8.px)
                }
            }) {
                Text("Cargando mapa general de incidencias...")
            }
      }
    }

    val currentMarkers = if (uiState.filtroTipo == "Seguridad Ciudadana") markersSeguridadJson else markersJson
    LaunchedEffect(currentMarkers, incidencias.size) {
        if (currentMarkers.isNotBlank()) {
            js("initMapWithMarkers")(currentMarkers)
        }
    }
}
